export class ConfirmStatusChangeResponseModel {
  action: string;
  data: any;
}
